import { useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { listReportAccidentsService } from "../services/listReportAccidents.service";
import { useFetch } from "../../../common/hooks/useFetch";

const LIMIT = 20;

export const useReportAccidentQuery = (filters) => {
  const fetchData = useFetch();
  const [reportAccidents, setReportAccidents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.search, filters.startDate, filters.endDate]);

  useEffect(() => {
    const fetchReportAccidents = async () => {
      try {
        setLoading(true);
        const response = await listReportAccidentsService(fetchData)({
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT,
          ...filters,
        });

        setReportAccidents(response.data);
        setTotalItems(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchReportAccidents, 500);

    debounced();

    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refresh,
    currentPage,
    filters.search,
    filters.startDate,
    filters.endDate,
  ]);

  return {
    reportAccidents,
    loading,
    currentPage,
    totalPages,
    totalItems,
    refresh: () => setRefresh((prev) => !prev),
    onChangePage: (page) => setCurrentPage(page),
  };
};
